import React from 'react';
import { Mail, ArrowRight } from 'lucide-react';
import { contactInfo } from '../mock';

const Hero = ({ onGetQuote, onSeeWork }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Medusa Background Image - YOUR FAVORITE! */}
      <div className="absolute inset-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/eup6a7i9_highcontrast%20depicti%20%2814%29.jpg"
          alt="Medusa Queen - Signature Artwork"
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/70 to-black"></div>
      </div>

      {/* Animated gradient overlays */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 right-0 w-96 h-96 bg-purple-600/30 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-800/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      {/* Serpent pattern overlay */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <pattern id="serpent-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
            <path d="M20,50 Q30,30 40,50 T60,50 T80,50" stroke="#8A2BE2" strokeWidth="2" fill="none" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#serpent-pattern)" />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center">
        {/* Main Title */}
        <h1 className="font-bold text-6xl md:text-8xl lg:text-9xl mb-6 tracking-tight">
          <span className="block text-white">MEDUSAI</span>
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-purple-600 mt-2">
            GRAPHICS
          </span>
          <span className="block text-white mt-2">UNLIMITED</span>
        </h1>

        {/* Subtitle */}
        <p className="text-xl md:text-3xl text-purple-300 font-light mb-4 max-w-3xl mx-auto">
          Custom Wall Murals. Bold Graphics. Zero Limits.
        </p>

        {/* Contact Info Strip */}
        <div className="flex flex-wrap items-center justify-center gap-6 mb-12 text-gray-300">
          <a href={`mailto:${contactInfo.emailAlt}`} className="flex items-center gap-2 hover:text-purple-400 transition-colors">
            <Mail className="w-5 h-5" />
            <span className="font-mono text-sm md:text-base">{contactInfo.emailAlt}</span>
          </a>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={onGetQuote}
            className="group relative px-8 py-4 bg-purple-600 text-white rounded-full font-bold text-lg hover:bg-purple-700 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-purple-500/50 min-w-[200px]"
          >
            <span className="flex items-center justify-center gap-2">
              Get a Quote
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </span>
          </button>
          <button
            onClick={onSeeWork}
            className="px-8 py-4 bg-transparent border-2 border-purple-400 text-purple-400 rounded-full font-bold text-lg hover:bg-purple-400 hover:text-black transition-all duration-300 hover:scale-105 min-w-[200px]"
          >
            See Our Work
          </button>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-purple-400 rounded-full p-1">
            <div className="w-1 h-3 bg-purple-400 rounded-full mx-auto animate-pulse"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
